import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetIntents, GetIntentId } from "../api/IntentApiCall";
import { IntentDataModel } from "../api/responsePayload/IntentResponse";
import { showConsoleError } from "../util/ConsoleMessage";
import { resetPagination, setPagination } from "./pagination.slice";

interface IntentState {
  items: IntentDataModel[];
  loading: boolean;
  error?: string;
}

const initialIntentState: IntentState = { items: [], loading: false };

export const fetchIntents = createAsyncThunk(
  "intent/fetch",
  async (
    args:
      | { endpoint?: string; page?: number; queryParams?: Record<string, any> }
      | undefined,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const res = await GetIntents(
        args?.endpoint,
        args?.page,
        undefined,
        args?.queryParams ?? {}
      );
      if (res) {
        dispatch(
          setPagination({
            currentPage: res.current_page,
            nextPageUrl: res.next,
            prevPageUrl: res.previous,
            totalPages: res.total_pages,
            totalCount: res.count,
          })
        );
        return res.results as IntentDataModel[];
      }
      return [] as IntentDataModel[];
    } catch (e: any) {
      showConsoleError("fetchIntents error", e);
      return rejectWithValue(String(e));
    }
  }
);

export const fetchIntentById = createAsyncThunk(
  "intent/fetchById",
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const res = await GetIntentId(id);
      dispatch(resetPagination());

      const item: IntentDataModel | undefined =
        res && (res as any).data
          ? (res as any).data
          : (res as IntentDataModel | undefined);

      return item ? [item] : [];
    } catch (e: any) {
      showConsoleError("fetchIntentById error", e);
      return rejectWithValue(String(e));
    }
  }
);

export const intentSlice = createSlice({
  name: "intent",
  initialState: initialIntentState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIntents.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchIntents.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchIntents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchIntentById.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default intentSlice.reducer;
